<template>
<Row>
    <Col :span="20" :offset="2">
        <Tabs value="upload">
            <TabPane label="上传" name="upload"><upload></upload></TabPane>
            <TabPane label="访视" name="visit"><visit></visit></TabPane>
            <TabPane label="表单" name="domain"><domain></domain></TabPane>
        </Tabs>
    </Col>
</Row>
</template>

<script>
import DesignUpload from '@/views/design/DesignUpload'
import Visit from '@/views/design/Visit'
import Domain from '@/views/design/Domain'

export default {
  name: 'design',
  components: {
    upload: DesignUpload,
    visit: Visit,
    domain: Domain
  },
  data: function () {
    return {
      current: 'upload'
    }
  }
}
</script>
